export function buildTemplatesUrl(options: {
  type?: string
  brand?: string
  designer?: string
  /** Semantic search query (`q`). Blank values are omitted. */
  q?: string
  /** Defaults to `/templates`. Public marketing mirror uses `/browse/templates`. */
  basePath?: string
}): string {
  const params = new URLSearchParams()
  const base = options.basePath ?? '/templates'

  if (options.type) {
    params.set('type', options.type)
  }
  if (options.brand) {
    params.set('brand', options.brand)
  }
  if (options.designer) {
    params.set('designer', options.designer)
  }
  const query = options.q?.trim()
  if (query) {
    params.set('q', query)
  }

  const qs = params.toString()
  return qs ? `${base}?${qs}` : base
}

export function buildTemplateEmailPath(
  emailId: string,
  basePath = '/templates'
): string {
  const prefix = basePath.replace(/\/$/, '')
  return `${prefix}/email/${emailId}`
}

/**
 * The Flows pill: the curated collection of real brand email sequences
 * (`flowTemplates`), offered beside All / Forwarded / Sent but living on
 * its own pages (`/flows`, `/browse/flows`). Selecting it leaves the
 * templates gallery for the flows gallery with the query kept; a stale
 * `?type=flows` on the templates gallery redirects there.
 */
export const FLOWS_TYPE = 'flows'

export function templatesBasePathForSurface(surface: 'app' | 'public'): string {
  return surface === 'public' ? '/browse/templates' : '/templates'
}

export {
  buildFlowsUrl,
  flowsBasePathForSurface,
  publicFlowTemplatePath as buildFlowTemplatePath,
} from '@/lib/flow-templates/slug'
